import React from "react";
import TechnicalSkill from "../technicalSkill/technicalSkill";
import Constants from "../../../constants";
import TimelineList from "../timelineList/timelineList";
import { Navigate } from "react-router-dom";
let self;

export class TechnicalSkillList extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        self = this;
        this.state = { noOfSkills: 1, technicalSkillsList: [], isSkillAdditingDone: false , profileData: {}}
    }

    onTechnicalSkillAdded(data, isNext) {
        // console.log(data, isNext)
        let newData = {};
        if (isNext) {
            self.setState({ noOfSkills: self.state.noOfSkills + 1 })
        } else {
            self.setState({ isSkillAdditingDone: true })
            const data1: any = sessionStorage.getItem('portfolioForm')
            const previousData = JSON.parse(data1);
            newData = { ...previousData, technicalSkillsList: [...self.state.technicalSkillsList, data] }
            sessionStorage.setItem('portfolioForm', JSON.stringify(newData))  
        }
        self.setState({ technicalSkillsList: [...self.state.technicalSkillsList, data] });
        self.setState({ profileData: newData });       
    }
    render(): React.ReactNode {
        return (
            <>
                {!this.state.isSkillAdditingDone &&
                    <div className="form__wrapper">
                        {
                            Array.from({ length: this.state.noOfSkills }).map((e, i) => {
                                return <TechnicalSkill onTechnicalSkillAdded={this.onTechnicalSkillAdded} key={i} skillNo={i + 1} />
                            })
                        }
                    </div>
                }
                {
                    this.state.isSkillAdditingDone &&
                    <Navigate to="/timeline-list"  />

                }
            </>
        )
    }
}

export default TechnicalSkillList;